import { useDispatch, useSelector } from "react-redux"
import { State } from "../reducers"
import { REGEX_ALFANUM, REGEX_EMAIL, REGEX_INTEGER, REGEX_LETRAS_ESPACIOS, REGEX_NIT} from "../constants/Regex"
import * as http from '../api/http'
import { ENDPOINTS } from "../api/config"
import { KEYS } from "../constants/keysStorage"
import { generalOpenConfirmEdit, generalOpenModalError, generalOpenModalInfo, generalOpenModalMessage, generalOpenToastError, generalOpenToastInfo, generalOpenToastSuccess, generalShowLoader } from "./general.actions"
import { useEffect } from "react"

import FlechaDerechaIcon from '../media/felsv/white_right-arrow_icon.svg'
import EmitirIcon from '../media/felsv/white_check_icon.svg'
import MasOpcionesIcon from '../media/felsv/WhiteOpciones.svg'
import { getEmailNotifyMsg, unirChipsJoin, unirChipsReturnFirst, validarRegexLetras, validarRegexNumericoFloat2Decimales, validarRegexNumericoInt } from "../utils/strings.utils"
import { validarTipoDocumento } from "../utils/validaciones"
import { facturacionGetUUID } from "./facturacion/facturacionEmision.actions"
import { convertDateFormatAnular, getFechaFormato1 } from "../utils/stringDate"
import { anularFactura, anularFactura_DTE, descargarJson, generateQRImageFromBits, getExcelFactura, getFacturaImage, getFacturaPDF_New, getQR, sendTransactionEmail } from "./operaciones/operaciones.actions"
import { useHistory } from "react-router-dom"
import { OPSendEmail } from "../interfaces/operaciones.interface"
import { ActionFE, FEProducto } from "../interfaces/factura-exportacion.interface"
import { FACTURA_EXPORTACION_TYPES } from "../constants/factura-exportacion.types"
import { docsAsociadosReset, docsDatosReceptorSiguienteDispatch } from "./documentos/documentos.actions"
import { docsAsociadosItems } from "../pages/EmitirFactura/Components/GeneracionFactura/OtrosDocAsociados"
import { showMessageSucursalVacia } from "./userLogin.actions"
import { handleRestartStateFormaPago } from "./forma-pago.actions"
import useUtilsDocs from "./utils-documentos.actions"

export default function useFacturaExportacion (){
    const dteCode = "11";
    const {formCliente, formProducto, errorsCliente, errorsProducto, productos, view, productoEdit, productoIndex, response_Emitir, clienteEncontrado, paises, recintos, regimenes, inconterms, unidades} = useSelector((state: State) => state.facturaExportacion)
    const {departamentos, actividadesEconomicas, datosEmisor, condicionOperacion, tipoPersona} = useSelector((state: State) => state.catalogos)
    const {datosUUID} = useSelector((state: State) => state.facturacion)
    const {datos} = useSelector((state: State) => state.userLogin)
    const {dataDocsAsociados} = useSelector((state: State) => state.documentos.otrosDocumentosAsociados);
    const datosReceptor = useSelector((state: State) => state.documentos.datosReceptor.form);
    const {pagoCompletado, formFormaPago, pagos} = useSelector((state: State) => state.formaPago);
    
    const emisorGranContribuyente = datosEmisor?.tipoContribuyente === '1'
    const emisorJuridico = datosEmisor?.tipoEmpresa === '2'
    const dispatch = useDispatch()
    const history = useHistory()

    const {processFormCatalogoProducto} = useUtilsDocs();

    const cargarDatosIniciales = async() => {
        let fechaActual = new Date().toISOString().split('T')[0]
        let sucursalConDocumento = formCliente?.datosSucursal?.find((suc: any) => suc.Documento.find((doc: any) => doc.iddocumento === '11'))
        let documentoSucursal = sucursalConDocumento?.Documento.find((doc: any) => doc.iddocumento === '11')

        dispatch(handleSetFormCliente({
            ...formCliente,
            fecha: fechaActual,
            sucursal: sucursalConDocumento?.idsucursal,
            serie: documentoSucursal?.idsucursaldocumento
        }))
    }

    const cargarCatalogosExportacion = async() => {
        try{
            dispatch(generalShowLoader(true))

            await Promise.all([
                cargarRecintos(),
                cargarRegimenes(),
                cargarIncoterms(),
                cargarFormasPago(),
                cargarPaises(),
                cargarUnidades()
            ])

        } catch {
            dispatch(generalOpenModalError('Ocurrió un error al cargar los catálogos'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const onChangeFormCliente = (field: string, value: any) => {
        dispatch(handleSetBlockedData(true))
        if(!validateChange(field, value) && value.trim() !== '') return
        dispatch(handleSetFormCliente({...formCliente, [field] : value}))
        validateFormCliente(field, value)
    }

    const onChangeFormProducto = (field: string, value: any, extraData = {}) => {
        if(!validateChange(field, value) && value.trim() !== '') return
        dispatch(handleSetFormProducto({...formProducto, ...extraData, [field] : value}))
        validateFormProducto(field, value)
    }

    const onChangeSelectCatalogoProducto = (codeProduct: string) => {
        const newFormProducto = processFormCatalogoProducto(dteCode, formProducto, codeProduct)
        dispatch(handleSetFormProducto({...formProducto, ...newFormProducto}))
        validateFormProducto('descripcion', codeProduct);
    }

    const validateFormCliente = (field: string, value: string) => {
        let soloServicios = (productos.length > 0 && productos.some((item) => item.servicio) && !productos.some((item) => !item.servicio))
        
        let message = ''
        switch (field) {
            case 'nombre':
                if(!value || value.trim() === ''){message = 'Nombre es requerido'; break;}         
                break;
            case 'noDocumento':
                if(!value || value.trim() === ''){message = 'Número de identificación es requerido.'}
                switch(formCliente.tipoDocumento){
                    case '36':
                        if(!REGEX_NIT.test(value)) {message = 'Formato de NIT incorrecto'; break}
                        break;
                    case '03':
                        message = validarTipoDocumento('pasaporte', value, '')
                        break;
                    case '13':
                        if(!REGEX_INTEGER.test(value) || value.length > 9 || value.length < 9) {message = 'Formato de DUI incorrecto'; break}
                        break;
                    case '02':
                        message = validarTipoDocumento('carnet de residente', value, '')
                        break;
                    case '37':
                        message = validarTipoDocumento('otro', value, '')
                        break;
                }
                break;
            case 'direccion':
                if(!value || value.trim() === ''){message = 'Dirección es requerida.'}
                break;
            case 'email':
                const chipsEmail = formCliente.chipsEmail?.length || 0;
                if (value.trim() !== "" && !REGEX_EMAIL.test(value)) {message = 'Correo electrónico inválido'; break;}
                break;
            case 'telefono':
                if(value.trim().length < 11 && value.trim() !== ''){message = 'Teléfono celular inválido.'; break;}
                break;
            case 'actividad':
                if(!value || value.trim() === ''){message = 'Actividad económica es requerida.'; break;}
                break;
            case 'paisExportacion':
                if(!value || value.trim() === ''){message = 'País de exportación es requerido.'; break;}
                break;
            case 'descuentoGlobal':
                if(calculosProducto().total <= parseFloat(value || '0') && productos.length > 0){message = 'El descuento global no puede ser mayor al subtotal.'; break;}
                break;
            case 'persona':
                if(!value || value.trim() === ''){message = 'Tipo de persona es requerido.'}
                break;
            case 'sucursal':
                if(!value || value === ''){message = 'Sucursal es requerida'}
                break;
            case 'serie':
                if(!value || value === ''){message = 'Serie es requerida'}
                break;
        }

        dispatch(handleErrorsFormCliente({
            ...errorsCliente,
            [field] : message
        }))

        return (message)
    }

    const validateFormProducto = (field: string, value: string) => {
        let message = ''
        
        switch(field){
            case 'descripcion':
                if(value.trim() === ''){message = 'Descripción es obligatoria.'; break;}
                break;
            case 'cantidad':
                if(value.trim() === '' || parseFloat(value) === 0){message = 'La cantidad debe ser mayor a 0.'; break;}
                break;
            case 'unidad':
                if(value.trim() === ''){message = 'La unidad de medida es obligatoria.'; break;}
                break;
            case 'precio':
                if(value.trim() === '' || parseFloat(value) < 0){message = 'El precio debe ser mayor a 0.'; break;}
                break;
            case 'descuento':
                let suma = parseFloat(formProducto.cantidad) * parseFloat(formProducto.precio)
                if(parseFloat(value) >= 100 && formProducto.tipoDescuento === 'Porcentaje') {message = 'El porcentaje de descuento no puede ser mayor o igual al 100%.'; break;}
                if(formProducto.tipoDescuento === 'Monto'){
                    if(parseFloat(value) > suma){message = 'El monto de descuento no puede ser mayor al precio.'; break;}
                }
                break;
        }
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            [field] : message
        }))

        return (message)
    }

    const validateFormProductoEdit = (field: string, value: string) => {
        let message = ''
        
        switch(field){
            case 'descripcion':
                if(value.trim() === ''){message = 'Descripción es obligatoria.'; break;}
                break;
            case 'cantidad':
                if(value.trim() === '' || parseFloat(value) === 0){message = 'La cantidad debe ser mayor a 0.'; break;}
                break;
            case 'precio':
                if(value.trim() === '' || parseFloat(value) < 0){message = 'El precio debe ser mayor a 0.'; break;}
                break;
            case 'descuento':
                let suma = parseFloat(productoEdit.cantidad) * parseFloat(productoEdit.precio)
                if(parseFloat(value) > 100 && productoEdit.tipoDescuento === 'Porcentaje') {message = 'El porcentaje de descuento no puede ser mayor al 100%.'; break;}
                if(productoEdit.tipoDescuento === 'Monto'){
                    if(parseFloat(value) > suma){message = 'El monto de descuento no puede ser mayor al precio.'; break;}
                }
                break;
        }
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            [field] : message
        }))

        return (message)
    }

    const validateChange = (field: string, value: string) => {
        switch(field){
            case 'nombre':
                return (REGEX_LETRAS_ESPACIOS.test(value))
            case 'descripcion':
                    return validarRegexLetras(value);
            case 'cantidad':
                    return validarRegexNumericoFloat2Decimales(value);
            case 'precio':
                    if(parseFloat(value) > 100000000000) return
                    return validarRegexNumericoFloat2Decimales(value);
            case 'descuento':
            case 'montoFormaPago':
            case 'seguro':
            case 'flete':
            case 'descuentoGlobal':
                    if(parseFloat(value) > 100000000000) return
                    return validarRegexNumericoFloat2Decimales(value);
            case 'noDocumento':
                    switch (formCliente.tipoDocumento){
                        case '36':
                            if(value.length > 14) return false
                            return(validarRegexNumericoInt(value))
                        case '03':
                            return(REGEX_ALFANUM.test(value) && value.length <= 14)
                        case '13':
                            if(value.length > 9) return false
                            return(validarRegexNumericoInt(value))
                        case '02':
                            return(REGEX_ALFANUM.test(value) && value.length <= 14)
                        case '37':
                            return(validarRegexNumericoInt(value) && value.length <= 15)
                    }
                break;
            case 'nrc':
                return (!(value.length > 7))
            default:
                return true
        }
    }

    const cargarSucursales = async() => {
        const newFormCliente = { ...formCliente, datosSucursal: [], loadedSucursal: true };

        try {
            let message = 'No se logró obtener el catalogo de sucursales'
            const response: any = await api_getSucursales({
                idsucursal: `${datos.sucursal_seleccionada}`,
                tipodocumento: '11'
            })
            
            if (response.body && !response.message) {
                const sucursal = response.body;
                const hayDocs = sucursal[0]?.Documento?.length;
                
                if (hayDocs) {
                    newFormCliente.datosSucursal = sucursal;
                }
                dispatch(handleSetFormCliente(newFormCliente));
            } else {
                dispatch(generalOpenModalError(response.message || message))
            }
        } catch (error: any) {
            if(error?.response?.data?.errorCode === 1) { dispatch(handleSetFormCliente(newFormCliente)); return; }
            dispatch(generalOpenModalError(error?.response?.data?.message ?? 'Error al obtener las sucursales', error?.response?.data?.status))
        }
    }

    const cargarRecintos = async() => {
        try {
            const response: any = await api_getRecintosFiscales()
            if(Array.isArray(response.body) && response.body.length > 0){
                dispatch(handleSetRecintos(response.body))
            } else {
                dispatch(generalOpenModalInfo(response?.message || 'No se cargaron los recintos fiscales, recarga la página.'))
            }
            
        } catch (error: any) {
            dispatch(generalOpenModalError(error?.response?.data?.message ?? 'Error al obtener los recintos fiscales', error?.response?.data?.status))
        }
    }

    const cargarRegimenes =async () => {
        try {
            const response: any = await api_getRegimenes()
            if(Array.isArray(response.body) && response.body.length > 0){
                dispatch(handleSetRegimenes(response.body))
            } else if(Array.isArray(response.data) && response.data.length > 0){
                dispatch(handleSetRegimenes(response.data))
            } else {
                dispatch(generalOpenModalInfo(response?.message || 'No se cargaron los régimenes fiscales, recarga la página.'))
            }
            
        } catch (error: any) {
            dispatch(generalOpenModalError(error?.response?.data?.message ?? 'Error al obtener los régimenes fiscales', error?.response?.data?.status))
        }
    }

    const cargarPaises =async () => {
        try {
            const response: any = await api_getPaises()
            if(Array.isArray(response.body) && response.body.length > 0){
                dispatch(handleSetPaises(response.body))
            } else {
                dispatch(generalOpenModalInfo(response?.message || 'No se cargaron los régimenes fiscales, recarga la página.'))
            }
            
        } catch (error: any) {
            dispatch(generalOpenModalError(error?.response?.message ?? 'Error al obtener el catálogo de paises', error?.response?.status))
        }
    }

    const cargarUnidades =async () => {
        try {
            const response: any = await api_getUnidadMedida()
            if(Array.isArray(response.body) && response.body.length > 0){
                dispatch(handleSetUnidades(response.body))
            } else {
                dispatch(generalOpenModalInfo(response?.message || 'No se cargaron las unidades de medida, recarga la página.'))
            }
            
        } catch (error: any) {
            dispatch(generalOpenModalError(error?.response?.message ?? 'Error al obtener el catálogo de paises', error?.response?.status))
        }
    }

    const cargarIncoterms =async () => {
        try {
            const response: any = await api_getIconterms()
            if(Array.isArray(response.body) && response.body.length > 0){
                dispatch(handleSetIconterms(response.body))
            } else {
                dispatch(generalOpenModalInfo(response?.message || 'No se pudo obtener el catálogo de Incoterms, recarga la página.'))
            }
            
        } catch (error: any) {
            dispatch(generalOpenModalError(error?.response?.data?.message ?? 'Error al obtener el catálogo de Incoterms', error?.response?.data?.status))
        }
    }

    const cargarFormasPago =async () => {
        try {
            const response: any = await api_getFormasPago()
            if(Array.isArray(response.body) && response.body.length > 0){
                dispatch(handleSetFormasPago(response.body))
            } else {
                dispatch(generalOpenModalInfo(response?.message || 'No se pudieron obtener las formas de pago, recarga la página.'))
            }
            
        } catch (error: any) {
            dispatch(generalOpenModalError(error?.response?.data?.message ?? 'Error al obtener las formas de pago', error?.response?.data?.status))
        }
    }

    const button_onClickAgregarProducto = () => {
        let id = productos.length
        let errors: { [key: string]: string } = {};

        Object.keys(formProducto).forEach((key) => {
            if (validateFormProducto(key, formProducto[key])){
                let propiedad = key
                let value = validateFormProducto(key, formProducto[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            ...errors
        }))

        if(Object.values(errors).some((err) => err !== '')){
            dispatch(generalOpenModalInfo('Revisa el formulario de producto'))
            return;
        }

        let tempArray = productos
        tempArray.push({...formProducto, id: id})
        dispatch(handleAddProducto(tempArray))     
        dispatch(generalOpenModalInfo('Producto agregado correctamente.'))   
        dispatch(handleRestartFormProducto())
    }

    const button_onClickLimpiarFormProducto = () => {
        dispatch(handleRestartFormProducto())
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            descripcion: '',
            cantidad: '',
            precio: '',
            descuento: ''
        }))
    }

    const footer_onClickNext = async() => {
        switch (view) {
            case 'Formularios':
                let errors: { [key: string]: string } = {};

                Object.keys(formCliente).forEach((key) => {
                if (validateFormCliente(key, formCliente[key])){
                    let propiedad = key
                    let value = validateFormCliente(key, formCliente[key])
                    errors[propiedad] = value
                }
                })
                dispatch(handleErrorsFormCliente({
                    ...errors
                }))

                if(Object.values(errors).some((err) => err !== '')){
                    dispatch(generalOpenModalInfo('Revisa los datos del formulario de cliente.'))
                    return;
                }

                if(productos.length === 0){
                    dispatch(generalOpenModalInfo('Debes agregar al menos un producto para continuar.'))
                    return;
                }
                
                const datosReceptor:any = dispatch(docsDatosReceptorSiguienteDispatch())
                if(datosReceptor === true) return;

                if(calculosProducto().total >= 2147483647){
                    dispatch(generalOpenToastError('Las operaciones que intentas realizar estàn fuera del lìmite permitido'))
                    return;
                }

                if(!pagoCompletado){
                    dispatch(generalOpenModalInfo('El monto total de pago debe ser igual al total a pagar'))
                    return
                }

                try {
                    dispatch(generalShowLoader(true))
                    await Promise.all([
                        dispatch(facturacionGetUUID('11', false))
                    ])
                } finally {
                    dispatch(generalShowLoader(false))
                }
                dispatch(handleChangeView('Previsualizacion'))
                break;
            case 'Previsualizacion':
                dispatch(handleActiveModalEmitir(true))
                break;
            case 'Detalle':
                dispatch(handleActiveModalMasOpciones(true))
                break;
        }
    }

    const footer_onClickBack = () => {
        switch (view) {
            case 'Formularios':
                if(productos.length > 0) dispatch(handleActiveModalQuitarTodo(true))
                break;
            case 'Previsualizacion':
                dispatch(handleChangeView('Formularios'))
                break;
            case 'Detalle':
                dispatch(handleRestartStateFormaPago())
                dispatch(handleRestarFlujo())
                dispatch(docsAsociadosReset());
                break;
        }
    }

    const footer_textButtons = () => {
        let textBack = ''
        let textNext = ''
        let iconBack = ''
        let iconNext = ''
        switch(view){
            case 'Formularios':
                textBack = 'Quitar todo'
                textNext = 'Siguiente'
                iconBack = ''
                iconNext = FlechaDerechaIcon
                break;
            case 'Previsualizacion':
                textBack = 'Anterior'
                textNext = 'Emitir'
                iconBack = ''
                iconNext = EmitirIcon
                break;
            case 'Detalle':
                textBack = ''
                textNext = 'Más opciones'
                iconBack = ''
                iconNext = MasOpcionesIcon
                break;
        }

        return {
            next: {
                text: textNext,
                icon: iconNext
            },
            back: {
                text: textBack,
                icon: iconBack
            }
        }
    }

    const button_onClickQuitarTodo = () => {
        dispatch(handleAddProducto([]))
        modal_cerrarQuitarTodo()
        dispatch(generalOpenModalInfo('Se eliminaron todos los productos de la lista'))
    }

    const actionButton_editar = (producto: FEProducto, index: any) => {
        let tempForm: { [key: string]: any } = {
            ...productoEdit,
            ...producto
        }

        let errors: { [key: string]: string } = {};

        Object.keys(tempForm).forEach((key) => {
            if (validateFormProducto(key, tempForm[key])){
                let propiedad = key
                let value = validateFormProducto(key, tempForm[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormProducto({
            ...errors
        }))

        dispatch(handleSetIndexProductoEdit(producto.id))
        dispatch(handleActiveModalEditar(true))
        dispatch(handleSetProductoEdit(producto))
    }
    
    const modal_cerrarModalEditar = () => {
        button_onClickLimpiarFormProducto()
        dispatch(handleSetIndexProductoEdit(null))
        dispatch(handleActiveModalEditar(false))
        dispatch(handleSetProductoEdit({
            ...productoEdit,
            descripcion: '',
            cantidad: '',
            precio: '',
            descuento: ''
        }))
        
    }

    const actionButton_eliminarProducto = (index: any) => {
        dispatch(handleSetIndexProductoEdit(index))
        dispatch(handleActiveModalEliminar(true))
    }
    
    const modal_button_onConfirmEliminar = () => {
        let tempArray = productos
        tempArray.splice(productoIndex, 1); // Elimina el objeto del arreglo
        // Recalcula los 'id' después de la eliminación
        tempArray.forEach((obj, idx) => {
        obj.id = idx;
        });
        //------------------------------------------------
        // tempArray.splice(productoIndex, 1)
        dispatch(handleAddProducto(tempArray))
        dispatch(generalOpenModalInfo('Producto eliminado exitosamente.'))
        modal_cerrarModalEliminar()
    }
    
    const modal_cerrarModalEliminar = () => {
        dispatch(handleSetIndexProductoEdit(null))
        dispatch(handleActiveModalEliminar(false))
    }

    const modal_onChangeFormProductoEdit = (field: string, value: string) => {
        if(!validateChange(field, value) && value.trim() !== '') return

        dispatch(handleSetProductoEdit({
            ...productoEdit,
            [field] : value
        }))

        validateFormProductoEdit(field, value)
    }

    const modal_onChangeSelectCatalogoProductoEdit = (codeProduct: string) => {
        const newFormProductoEdit = processFormCatalogoProducto(dteCode, productoEdit, codeProduct)
        dispatch(handleSetProductoEdit({...productoEdit, ...newFormProductoEdit}))
    }

    const modal_button_onConfirmEdit = () => {
        dispatch(generalOpenConfirmEdit(action_onConfirmEdit))
    }

    const action_onConfirmEdit = () => {
        let errors: { [key: string]: string } = {};

        Object.keys(productoEdit).forEach((key) => {
            if (validateFormProducto(key, productoEdit[key])){
                let propiedad = key
                let value = validateFormProductoEdit(key, productoEdit[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            ...errors
        }))

        if(Object.values(errors).some((err) => err !== '')){
            dispatch(generalOpenModalInfo('Revisa los datos del producto'))
            return;
        }

        let tempArray = productos
        tempArray[productoEdit.id] = productoEdit
        dispatch(handleAddProducto(tempArray))
        modal_cerrarModalEditar()
        dispatch(generalOpenModalInfo('Producto actualizado exitosamente.'))
    }

    const modal_cerrarQuitarTodo = () => {
        dispatch(handleActiveModalQuitarTodo(false))
    }

    const modal_cerrarEmitir = () => {
        dispatch(handleActiveModalEmitir(false))
    }

    const modal_button_emitirNuevo = async() => {
        dispatch(handleAddProducto([]))
        dispatch(handleRestartStateFormaPago())
        dispatch(docsAsociadosReset());
        await dispatch(handleRestarFlujo())
        await dispatch(handleSetFormCliente(
            {
                fecha: '',
                tipoDocumento: '',
                noDocumento: '',
                nombre: '',
                departamento: '',
                municipio: '',
                direccion: '',
                email: '',
                chipsEmail: [],
                telefono: '',
                actividad: '',
                actividadDescripcion: '',
                departamentoDescripcion: '',
                municipioDescripcion: '',
                nrc: '',
                
                datosSucursal: [],
                datosDocumento: [],
        
                sucursal: '',
                serie: '',
                loadedSucursal: false,
            }
        ))
        await dispatch(handleAddProducto([]))
        setTimeout(() => {
            dispatch(handleChangeView('Formularios'))
        }, 2)
        dispatch(handleAddProducto([]))
    }

    const guardarCliente = async() => {
        try {
            let body = {
                opcion: 2,
                tipoDocumento: formCliente.tipoDocumento,
                numDocumento:  formCliente.noDocumento,
                nombre:  formCliente.nombre,
                direccion: formCliente.direccion,
                email: unirChipsJoin(formCliente.chipsEmail, formCliente.email),
                telefono:  formCliente.telefono,
                nrc:  formCliente.nrc,
                codActividad:  formCliente.actividad,
                descActividad:  actividadesEconomicas.find((actividad) => actividad.codigo === formCliente.actividad)?.valor,
                departamento: formCliente.departamento,
                municipio: formCliente.municipio,
              }
            const response: any = await api_buscarCliente(body)
            if (response){
                dispatch(generalOpenToastSuccess(response?.message || "Los datos del cliente han sido guardados satisfactoriamente."))
            }
        } catch (error: any) {
            dispatch(generalOpenToastError(error?.response?.data?.message || 'Se produjo un error al guardar la información del cliente.', "Alerta"))
        }
    }

    const buscarCliente = async() => {
        if(formCliente.tipoDocumento && formCliente.noDocumento && (validateFormCliente('noDocumento', formCliente.noDocumento) === '')){
            // dispatch(generalShowLoader(true))
            try {
                let body = {
                    opcion: '1',
                    tipoDocumento: formCliente.tipoDocumento,
                    numDocumento: formCliente.noDocumento
                }

                const user: any = await api_buscarCliente(body)

                if(user?.body !== null){
                    if (user?.body?.notificarcorreo?.length > 0) { dispatch(generalOpenModalInfo(getEmailNotifyMsg(user.body.notificarcorreo))); }
                    dispatch(handleSetInfoClienteEncontrado(user.body))
                    dispatch(handleActiveModalClienteEncontrado(true))
                } else {
                    dispatch(generalOpenToastInfo('El cliente es nuevo y será registrado al finalizar la factura, para llenarlo automáticamente en un nuevo documento.', 'Aviso'))
                    dispatch(handleSetInfoClienteEncontrado(null))
                }

            } catch (err: any) {
                dispatch(generalOpenToastError(err?.response?.data?.message || 'Se produjo un error al buscar la información del cliente.', "Alerta"))
            } finally {
                // dispatch(generalShowLoader(false))
            }
        }
    }

    const modal_button_verDetalle = () => {
        dispatch(handleChangeView('Detalle'))
        dispatch(handleActiveModalEmitido(false))
        modal_cerrarEmitir()
    }

    const modal_cerrarMasOpciones = () => {
        dispatch(handleActiveModalMasOpciones(false))
        dispatch(handleActiveModalEmitido(false))
    }

    const modal_button_cerrarModalEmitido = () => {
        dispatch(handleRestarFlujo())
        dispatch(handleRestartStateFormaPago())
        dispatch(docsAsociadosReset());
        dispatch(handleAddProducto([]))
        dispatch(handleActiveModalEmitido(false))
        history.push('/otros-documentos')
    }

    const modal_button_enviarCorreo = () => {
        dispatch(handleActiveModalCorreo(true))
    }

    const modal_button_cerrarEnviarCorreo = () => {
        dispatch(handleActiveModalCorreo(false))
    }

    const modal_button_descargarExcel = async() => {
        try {
            dispatch(generalShowLoader(true))
            await dispatch(getExcelFactura(
                {
                    Documento: response_Emitir.JsonFactura,
                    Sello: response_Emitir.Sello,
                },
                response_Emitir.codigoGeneracion
            ))
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al descargar el Excel.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_descargarImagen = async() => {
        try {
            dispatch(generalShowLoader(true))
            await dispatch(getFacturaImage(
                {
                    Documento: response_Emitir.JsonFactura,
                    Sello: response_Emitir.Sello,
                },
                response_Emitir.codigoGeneracion
            ))
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al descargar la imagen.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_descargarPDF = async() => {
        try {
            dispatch(generalShowLoader(true))
            await dispatch(getFacturaPDF_New(
                {
                    Documento: response_Emitir.JsonFactura,
                    Sello: response_Emitir.Sello,
                },
                response_Emitir.serie,
                response_Emitir.estadoanulacion
            ))
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al descargar el PDF.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_imprimir = () => {
        dispatch(handleActiveModalImprimir(true))
    }

    const modal_cerrarImprimir = () => {
        dispatch(handleActiveModalImprimir(false))
    }

    const modal_button_imprimirTicket = () => {
        dispatch(handleActiveModalImprimir(true))
    }

    const modal_button_descargarPDFTicket = async () => {
        try {
            dispatch(generalShowLoader(true))
            await dispatch(getFacturaPDF_New(
                { Documento: response_Emitir.JsonFactura, Sello: response_Emitir.Sello, ModoTicket: true },
                response_Emitir.serie, response_Emitir.estadoanulacion
            ))
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al descargar el Ticket PDF.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_onClickEnviarCorreo = async(email: string) => {
        try {
            dispatch(generalShowLoader(true))
            const sendEmail: OPSendEmail = {
                Correo: email,
                Documento: response_Emitir.JsonFactura,
                Sello: response_Emitir.Sello,
                json: response_Emitir?.JsonFacturaFile || "",
                idSucursal: datos?.sucursal_seleccionada,
                idEmpresa: `${datos?.codigo_empresa}`
            }
            const res:any = await dispatch(sendTransactionEmail(sendEmail))
            if(res){
                dispatch(generalOpenModalMessage('Enviar por correo electrónico', 'El correo electrónico fue enviado exitosamente.'))
                return true;
            }
        } catch (error: any) {
            dispatch(generalOpenModalError(error?.response?.data?.message || 'Ocurrió un error al enviar el correo'))
            return false
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_descargarJson = () => dispatch(descargarJson({idFactura: response_Emitir?.codigoGeneracion, json: response_Emitir?.JsonFacturaFile})) 

    const modal_button_anular = () => {
        dispatch(handleActiveModalAnular(true))
    }

    const modal_cerrarAnular = () => {
        dispatch(handleActiveModalAnular(false))
    }

    const modal_cerrarClienteEncontrado = () => {
        dispatch(handleActiveModalClienteEncontrado(false))
    }

    const modal_button_aceptarClienteEncontrado = async() => {
        let tempForm: { [key: string]: any } = {
            ...formCliente,
            nombre: clienteEncontrado.nombre,
            tipoDocumento: clienteEncontrado.tipoDocumento,
            noDocumento: clienteEncontrado.numDocumento,
            direccion: clienteEncontrado.direccion,
            email: '',
            chipsEmail: clienteEncontrado.email.split(','),
            telefono: clienteEncontrado.telefono,
            nrc: clienteEncontrado.nrc,
            actividad: clienteEncontrado.codActividad,
            departamento: clienteEncontrado.departamento,
            municipio: clienteEncontrado.municipio
        }

        let errors: { [key: string]: string } = {};

        Object.keys(tempForm).forEach((key) => {
            if (validateFormCliente(key, tempForm[key]) && key !== "email"){
                let propiedad = key
                let value = validateFormCliente(key, tempForm[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormCliente({
            ...errors
        }))        

        dispatch(handleSetFormCliente(tempForm))
        modal_cerrarClienteEncontrado()
    }

    const modal_button_onConfirmAnular = async() => {
        dispatch(generalShowLoader(true))

        try {
            //------------------------
            let documento = formCliente?.datosSucursal?.find((sucursal: any) => sucursal?.idsucursal === formCliente?.sucursal)?.Documento?.find((doc: any) => doc?.idsucursaldocumento === formCliente?.serie)
            let serie = `${documento?.serie}-${documento?.numeroactual}`
            let ivaTotal = 0
            productos.forEach((producto) => {
                let precioUnitario = producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio)
                let ivaProducto = (precioUnitario * 0.13) * parseFloat(producto.cantidad)
                if(!producto.exento){
                    ivaTotal += ivaProducto
                }
            })
            //------------------------
            
            const anularDoc = {
              documento: response_Emitir.JsonFactura,
              sellorecibido: response_Emitir.Sello,
              DetallesDTE: {
                receptor: {
                  numDocumento: formCliente.noDocumento,
                  tipoDocumento: formCliente.tipoDocumento,
                  nrc: formCliente.nrc,
                  nombre: formCliente.nombre?.trim(),
                  telefono: formCliente.telefono?.trim(),
                  correo: unirChipsReturnFirst(formCliente.chipsEmail, formCliente.email),
                },
                emisor: {
                  nombre: datosEmisor.nombre,
                  nit: datosEmisor.nit,
                  nrc: datosEmisor.nrc,
                  telefono: datosEmisor.telefono,
                  correo: datosEmisor.correo,
                  tipoEstablecimiento: datosEmisor.tipoestablecimiento,
                },
                resumen: {
                  totalIva: isNaN(ivaTotal) ? '0' : `${ivaTotal.toFixed(2)}`,
                },
                identificacion: {
                  tipoDte: '11',
                  codigoGeneracion: response_Emitir.codigoGeneracion,
                  numeroControl: `DTE-11-${serie}`,
                  fecEmi: convertDateFormatAnular(response_Emitir.fhProcesamiento.split(' ')[0]),
                  IDsucursalDoc: documento.idsucursaldocumento
                },
              },
            }
            const response: any = await dispatch(anularFactura_DTE(anularDoc))
            if(response){
                dispatch(generalOpenModalInfo('Documento anulado exitosamente'))
                modal_button_emitirNuevo()
            }
            

        } catch (error: any) {
            dispatch(generalOpenModalError(error?.response?.data?.body?.descripcionMsg || 'Ocurrió un error al anular el documento.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_emitirDocumento = async() => {
        let soloServicios = (productos.length > 0 && productos.some((item) => item.servicio) && !productos.some((item) => !item.servicio))
        dispatch(generalShowLoader(true))
        try{
            guardarCliente()
            // -----------------------------------------------------------------
            let sumaOperaciones = 0
            let subtotal = 0
            let descuentoTotal = 0
            let total = 0
            productos.forEach((producto) => {
                let precioUnitario = parseFloat(producto.precio)
                let descuento = isNaN(parseFloat(producto.descuento)) ? 0 : producto.tipoDescuento === 'Porcentaje' ? (precioUnitario * (parseFloat(producto.descuento)/100)) * parseFloat(producto.cantidad) : parseFloat(producto.descuento)
                sumaOperaciones += ((precioUnitario * parseFloat(producto.cantidad)) - descuento)
                subtotal += ((precioUnitario * parseFloat(producto.cantidad)) - descuento)
                descuentoTotal += descuento
            })

            subtotal = subtotal + parseFloat(formCliente.seguro || '0') + parseFloat(formCliente.flete || '0')
            // descuentoTotal += parseFloat(formCliente.descuentoGlobal || '0')<
            total = subtotal - descuentoTotal
            let documento = formCliente?.datosSucursal?.find((sucursal: any) => sucursal?.idsucursal === formCliente?.sucursal)?.Documento?.find((doc: any) => doc?.idsucursaldocumento === formCliente?.serie)
            let serie = `${documento?.serie}-${documento?.numeroactual}`

            let body: any = {
                id_user: localStorage.getItem(KEYS.ID_CLIENT),
                facturas:
                [{
                    receptorManual: datosReceptor.nombre,
                    docManual: datosReceptor.numId,
                    esReceptorManual : datosReceptor.esReceptorManual,
                    tipoDocManual : datosReceptor.nombreTipoDocumento,
                    idsucursaldocumento: formCliente.serie,
                    receptorEmailsEnvio: unirChipsJoin(formCliente.chipsEmail, formCliente.email),
                    tipoDte:"11",
                    cveDoc: serie,
                    uuid: datosUUID?.CodigoGeneracion,
                    fechaDoc: `${getFechaFormato1()} ${new Date().toLocaleTimeString([], {hour: '2-digit', minute: '2-digit', second: '2-digit'})}`,
                    // canTotal: `${sumaOperaciones.toFixed(2)}`,
                    canTotal: `${sumaOperaciones.toFixed(2)}`,
                    impuTotal: `0`,
                    impuTotal2: '0',
                    impuTotal3: '0',
                    expSubtotal: subtotal,
                    extTotal: (total - parseFloat(formCliente.descuentoGlobal || '0')).toFixed(2),
                    descuentoTotal: `${descuentoTotal.toFixed(2)}`,
                    seguro: parseFloat(formCliente.seguro || '0').toFixed(2),
                    flete: parseFloat(formCliente.flete || '0').toFixed(2),
                    descuentoGlobal: parseFloat(formCliente.descuentoGlobal || '0').toFixed(2),
                    condicionOperacion: formFormaPago.condicion,
                    formapago: pagos.map((pago) => {
                        return (
                            {
                                codigo: pago.formaPago,
                                montoPago: parseFloat(pago.monto).toFixed(2),
                                referencia: pago.numeroDocumento || '',
                                plazo: pago.plazo,
                                periodo: pago.periodo
                            }
                        )
                    }),
                    cuerpoDocumento: productos.map((producto) => {
                        let precioUni = parseFloat(producto.precio)
                        let descuento = 0


                        //DESCUENTO
                        switch(producto.tipoDescuento){
                            case 'Porcentaje':
                                descuento = (precioUni * (parseFloat(producto.descuento)/100)) * parseFloat(producto.cantidad)
                                break;
                            case 'Monto':
                                descuento = parseFloat(producto.descuento)
                                break;
                        }

                        return ({
                            cantidad: `${parseFloat(producto.cantidad).toFixed(2)}`,
                            precioUni: `${precioUni.toFixed(2)}`,
                            impuesoItem: `0`,
                            impuesoItem2: `0`,
                            impuesoItem3: `0`,
                            impuesto: '0',
                            impuesto2: '0',
                            impuesto3: '0',
                            descripcion: producto.descripcion,
                            descuento: isNaN(descuento) ? '0' : `${descuento.toFixed(2)}`,
                            TipoMonto: '0',
                            TipoItem: producto.servicio ? '0' : '1',
                            descUnidad: unidades.find((unidad: any) => unidad.codigo === producto.unidadMedida)?.valor,
                            unidad: producto.unidadMedida,
                            codigo: producto.clave ?? '',
                        })
                    }),
                    receptor: {
                        tipoDocumento:formCliente.tipoDocumento,
                        numDocumento: formCliente.noDocumento,
                        nombre: formCliente.nombre,
                        email: unirChipsReturnFirst(formCliente.chipsEmail, formCliente.email), //OPCIONAL
                        telefono: formCliente.telefono, //OPCIONAL
                        codActividad: formCliente.actividad,
                        descAtvividad: actividadesEconomicas.find((actividad) => actividad.codigo === formCliente.actividad)?.valor,
                        recintoFiscal: soloServicios ? '' : formCliente.recintoFiscal,
                        recintoFiscalDesc: soloServicios ? '' : recintos.find((recinto: any) => recinto.codigo === formCliente.recintoFiscal)?.valor,
                        regimen: soloServicios ? '' : formCliente.regimenExportacion,
                        regimenDesc: soloServicios ? '' : regimenes.find((reg: any) => reg.codigo === formCliente.regimenExportacion)?.valor,
                        incoterms: formCliente.incoterms,
                        incotermsDesc: inconterms.find((inc: any) => inc.codigo === formCliente.incoterms)?.valor,
                        tipoPersona: formCliente.persona,
                        descTipoPersona: tipoPersona.find((persona) => persona.codigo === formCliente.persona)?.valor,
                        codPais: formCliente.paisExportacion,
                        nombrePais: paises.find((pais: any) => pais.codigo === formCliente.paisExportacion)?.valor,
                        direccion: formCliente.direccion,
                        nombreComercial: ''
                    },
                    otrosDocumentos: dataDocsAsociados.map((doc:any) => ({
                        detalleDocumento: doc.descripcion,
                        descDocumento: doc.identificacion,
                        codDocAsociado: parseInt(doc.tipo),
                        descCodDocAsociado: `${doc.tipo}-${docsAsociadosItems.find((tipo) => tipo.codigo === doc.tipo)?.valor}`
                    }))
                  }],
                    tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
                    tokenHacienda: localStorage.getItem(KEYS.HACIENDA) ?? '',
                    idSucursal: datos?.sucursal_seleccionada,
                    idEmpresa: `${datos?.codigo_empresa}`
                }

                const response: any = await api_RecepcionDTE(body)
                if(response.body.estado === 'PROCESADO'){
                    if(response?.body?.NuevoToken){
                        localStorage.setItem(KEYS.HACIENDA, response?.body?.TokenHacienda)
                      }
                    dispatch(handleSetResponseEmitir(response.body))
                    dispatch(handleActiveModalEmitido(true))
                    dispatch(handleActiveModalEmitir(false))
                    dispatch(handleChangeView('Detalle'))
                  const qrResponse = await getQR(response.body.JsonFactura)
                  if(qrResponse.qr){
                      let qrString = generateQRImageFromBits(qrResponse.qr?.replace("data:image/jpeg;base64,", ""))
                      dispatch(handleSetQRCode(qrString))
                  } else {
                      dispatch(generalOpenModalError(qrResponse.message || 'Ocurrió un error al obtener el código QR'))
                  }
                }

        } catch (err: any) {
            let message = 'Ocurrió un error al emitir el crédito fiscal, contacta al administrador.'

            if(err.response.data.message) message = err.response.data.message
            else {
                try{
                    let messageDesc = err?.response?.data?.body?.descripcionMsg?.replace(/\[(\w+)\.(\w+)\]\s(\w+)/, '$2 de $1 : $3').toUpperCase()
                    message = messageDesc || message
                } catch {
                    message = 'Ocurrió un error al emitir el crédito fiscal, contacta al administrador.'
                }
            }

            dispatch(generalOpenModalError(message))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const mostrarObservacionesError = (arrayObservaciones: any, message: string): string => {
        if (Array.isArray(arrayObservaciones)) {
          const errorMessage = construirErrorMessage(arrayObservaciones);
          if (errorMessage) {
            message = errorMessage;
            if (contieneCampoReceptor(arrayObservaciones)) {
                dispatch(handleActiveModalEmitir(false))
                dispatch(handleChangeView('Formularios'))
            }
          }
        }
        return message;
      };

      const contieneCampoReceptor = (observaciones: string[]): boolean => {
        const cadena = 'Campo #/receptor';
        return observaciones.some((el: string) => el.trim().includes(cadena));
      };

      const construirErrorMessage = (observaciones: string[]): string => {
        let errorMessage = '';
        observaciones.forEach((el: string) => {
          if (formCliente.tipoDocumento === 'sinDocumento') {
            if (el.trim().includes('#/receptor/tipoDocumento')) {
              errorMessage += `<li>La cantidad a facturar no es permitida para la opción "Sin documento", debe seleccionar otro tipo de documento.</li>`;
            }
            if (el.trim().includes('#/receptor/numDocumento')) {
              errorMessage += `<li>La cantidad a facturar no es permitida para la opción "Sin documento", debe ingresar un número de documento.</li>`;
            }
          }  else if (el.trim().includes('Campo #/receptor/')) {
            el = el.replaceAll('Campo #/receptor/', 'Formulario con datos del cliente el campo: ');
            errorMessage += `<li>${el} o está vacío.</li>`;
          } else errorMessage += `<li>${el}.</li>`;
        });
        if (errorMessage)  errorMessage = `No se pudo generar el crédito fiscal, Hacienda solicita llenar los siguientes campos:<br><br><ol>${errorMessage}</ol>`;
        return errorMessage;
      };
      

    const calculosProducto = () => {
        let sumaOperaciones = 0
        let subtotal = 0
        let descuentoTotal = 0
        let total = 0
        productos.forEach((producto) => {
            let precioUnitario = parseFloat(producto.precio)
            let descuento = isNaN(parseFloat(producto.descuento)) ? 0 : producto.tipoDescuento === 'Porcentaje' ? (precioUnitario * (parseFloat(producto.descuento)/100)) * parseFloat(producto.cantidad) : parseFloat(producto.descuento)
            sumaOperaciones += ((precioUnitario * parseFloat(producto.cantidad)) - descuento)
            subtotal += ((precioUnitario * parseFloat(producto.cantidad)) - descuento)
            descuentoTotal += descuento
        })

        descuentoTotal += parseFloat(formCliente.descuentoGlobal || '0')
        total = subtotal + parseFloat(formCliente.seguro || '0') + parseFloat(formCliente.flete || '0')
        return {
        sumaOperaciones: sumaOperaciones,
        subtotal: subtotal,
        total: total
        }
    }

    const modal_button_anular2 = async () => {
        let documento = formCliente?.datosSucursal?.find((sucursal: any) => sucursal?.idsucursal === formCliente?.sucursal)?.Documento?.find((doc: any) => doc?.idsucursaldocumento === formCliente?.serie)
        let serie = `${documento?.serie}-${documento?.numeroactual}`
        let ivaTotal = 0
        productos.forEach((producto) => {
            let precioUnitario = producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio)
            let ivaProducto = (precioUnitario * 0.13) * parseFloat(producto.cantidad)
            if(!producto.exento){
                ivaTotal += ivaProducto
            }
        })
        const anularDoc: any = {
          documento: response_Emitir.JsonFactura,
          sellorecibido: response_Emitir.Sello,
          DetallesDTE: {
            receptor: {
                numDocumento: formCliente.noDocumento,
                tipoDocumento: formCliente.tipoDocumento,
                nrc: formCliente.nrc,
                nombre: formCliente.nombre,
                telefono: formCliente.telefono,
                correo: unirChipsReturnFirst(formCliente.chipsEmail, formCliente.email),
              },
            emisor: {
                nombre: datosEmisor.nombre,
                nit: datosEmisor.nit,
                nrc: datosEmisor.nrc,
                telefono: datosEmisor.telefono,
                correo: datosEmisor.correo,
                tipoEstablecimiento: datosEmisor.tipoestablecimiento,
              },
            resumen: {
              totalIva: ivaTotal,
            },
            identificacion: {
              tipoDte: '11',
              codigoGeneracion: response_Emitir.codigoGeneracion,
              numeroControl: `DTE-11-${serie}`,
              fecEmi: convertDateFormatAnular(response_Emitir.fhProcesamiento.split(' ')[0]),
            },
          },
        }
        dispatch(anularFactura([anularDoc]))
      }

    const setTableProductos = (table: any) => {
        dispatch(handleSetTableProductos(table))
    }

    useEffect(() => {
        
        let precioUnitario = parseFloat(formProducto.precio || '0')
        let descuento = 0
        if(formProducto.tipoDescuento === 'Porcentaje'){
            descuento = isNaN(parseFloat(formProducto.descuento)) ? 0 : (precioUnitario * parseFloat(formProducto.descuento)/100) * parseFloat(formProducto.cantidad)
        } else {
            descuento = isNaN(parseFloat(formProducto.descuento)) ? 0 : parseFloat(formProducto.descuento)
        }
        let neto = (parseFloat(formProducto.cantidad) * precioUnitario) 
        let subtotal = neto
        let iva = 0




        let total = subtotal - descuento
        

        dispatch(handleCalculosProducto({
            neto: isNaN(neto) ? '$0.00' : neto.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'}),
            subtotal: isNaN(subtotal) ? '$0.00' : subtotal.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'}),
            descuento: isNaN(descuento) ? '$0.00' : descuento.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'}),
            total: isNaN(total) ? '$0.00' : total.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'}),
            iva: isNaN(iva) ? '$0.00' : iva.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})
        }))

    }, [formProducto])

    useEffect(() => {
        if(formProducto.exento){
            dispatch(handleSetFormProducto({
                ...formProducto,
                conIva: false,
            }))
        }
    }, [formProducto.exento])

    useEffect(() => {
        if(formProducto.conIva){
            dispatch(handleSetFormProducto({
                ...formProducto,
                exento: false,
            }))
        }
    }, [formProducto.conIva])

    useEffect(() => {
        if(formCliente.tipoDocumento && formCliente.tipoDocumento !== '') validateFormCliente('noDocumento', formCliente.noDocumento)
    }, [formCliente.tipoDocumento])

    useEffect(() => {
        if(Array.isArray(formCliente.datosSucursal) && formCliente.datosSucursal.length > 0) cargarDatosIniciales()
        else if (formCliente.loadedSucursal) {
            dispatch(showMessageSucursalVacia('Factura de exportación'));
            history.push('/otros-documentos');
            dispatch(handleRestarFlujo());
        }
    }, [formCliente.datosSucursal, formCliente.loadedSucursal])

    useEffect(() => {
        if(formProducto.descuento){
            validateFormProducto('descuento', formProducto.descuento)
        }
    }, [formProducto])

    useEffect(() => {
        if(productoEdit.descuento){
            validateFormProductoEdit('descuento', productoEdit.descuento)
        }
    }, [productoEdit])

    useEffect(() => {
        if(productos.length > 0){
            dispatch(handleSetBlockedData(true))
        }
    }, [productos.length])

    return {
        cargarSucursales,
        cargarDatosIniciales,
        buscarCliente,
        cargarCatalogosExportacion,

        onChangeFormCliente,
        onChangeFormProducto,
        onChangeSelectCatalogoProducto,

        validateFormCliente,
        validateFormProducto,

        button_onClickAgregarProducto,
        button_onClickLimpiarFormProducto,
        button_onClickQuitarTodo,

        footer_onClickBack,
        footer_onClickNext,
        footer_textButtons,

        actionButton_editar,
        actionButton_eliminarProducto,

        modal_cerrarQuitarTodo,
        modal_cerrarModalEditar,
        modal_cerrarModalEliminar,
        modal_cerrarEmitir,
        modal_cerrarMasOpciones,
        modal_cerrarImprimir,
        modal_cerrarAnular,
        modal_cerrarClienteEncontrado,

        modal_button_onConfirmEdit,
        modal_button_onConfirmEliminar,
        modal_button_emitirDocumento,
        modal_button_emitirNuevo,
        modal_button_verDetalle,
        modal_button_cerrarModalEmitido,    
        modal_button_enviarCorreo,
        modal_button_cerrarEnviarCorreo,
        modal_button_onClickEnviarCorreo,
        modal_button_descargarExcel,
        modal_button_descargarImagen,
        modal_button_descargarPDF,
        modal_button_imprimir,
        modal_button_imprimirTicket,
        modal_button_descargarPDFTicket,
        modal_button_anular,
        modal_button_onConfirmAnular,
        modal_button_aceptarClienteEncontrado,
        modal_button_anular2,
        modal_button_descargarJson,
        
        modal_onChangeSelectCatalogoProductoEdit,
        modal_onChangeFormProductoEdit,
        setTableProductos

    }
}

const handleSetFormCliente = (form: any):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_SET_FORM_CLIENTE, payload: form})
const handleSetFormProducto = (form: any):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_SET_FORM_PRODUCTO, payload: form})
const handleErrorsFormCliente = (errors: any):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_HANDLE_ERRORS_CLIENTE, payload:errors})
const handleErrorsFormProducto = (errors: any):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_HANDLE_ERRORS_PRODUCTO, payload:errors})
const handleCalculosProducto = (calculos: any):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_SET_CALCULOS_PRODUCTO, payload: calculos})
const handleAddProducto = (productos: any):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_SET_PRODUCTOS, payload: productos})
const handleRestartFormProducto = ():ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_RESTART_FORM_PRODUCTO, payload: null})
const handleChangeView = (view: string):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_SET_VIEW, payload: view})
const handleActiveModalQuitarTodo = (active: boolean):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_ACTIVE_MODAL_QUITAR_TODO, payload: active})
const handleActiveModalEditar = (active: boolean):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_ACTIVE_MODAL_EDITAR_PRODUCTO, payload: active})
const handleActiveModalEliminar = (active: boolean):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_ACTIVE_MODAL_ELIMINAR_PRODUCTO, payload: active})
const handleActiveModalEmitir = (active: boolean):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_ACTIVE_MODAL_EMITIR, payload: active})
const handleActiveModalEmitido = (active: boolean):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_ACTIVE_MODAL_EMITIDO, payload: active})
const handleActiveModalMasOpciones = (active: boolean):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_ACTIVE_MODAL_MAS_OPCIONES, payload: active})
const handleActiveModalCorreo = (active: boolean):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_ACTIVE_MODAL_ENVIAR_CORREO, payload: active})
const handleActiveModalImprimir = (active: boolean):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_ACTIVE_MODAL_IMPRIMIR, payload: active})
const handleActiveModalClienteEncontrado = (active: boolean):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_ACTIVE_MODAL_CLIENTE_ENCONTRADO, payload: active})
const handleActiveModalAnular = (active: boolean):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_ACTIVE_MODAL_ANULAR, payload: active})
const handleActiveModalAnulado = (active: boolean):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_ACTIVE_MODAL_ANULADO, payload: active})
const handleSetProductoEdit = (producto: any):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_SET_PRODUCTO_EDIT, payload: producto})
const handleSetIndexProductoEdit = (index: any):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_SET_PRODUCTO_INDEX, payload: index})
const handleSetResponseEmitir = (response: any):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_SET_RESPONSE_EMITIR, payload: response})
const handleSetQRCode = (qr: any):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_SET_QR_CODE, payload: qr})
export const handleRestarFlujo = ():ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_RESTART_ALL, payload: true})
const handleSetInfoClienteEncontrado = (info: any):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_SET_CLIENTE_ENCONTRADO, payload: info})
const handleSetRecintos = (datos: any):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_SET_RECINTOS, payload: datos})
const handleSetRegimenes = (datos: any):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_SET_REGIMENES, payload: datos})
const handleSetPaises = (datos: any):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_SET_PAISES, payload: datos})
const handleSetUnidades = (datos: any):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_SET_UNIDADES, payload: datos})
const handleSetIconterms = (datos: any):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_SET_INCOTERMS, payload: datos})
const handleSetFormasPago = (datos: any):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_SET_FORMAS_PAGO, payload: datos})
const handleSetBlockedData = (block: boolean):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_SET_BLOCKED_DATA, payload: block})
const handleSetTableProductos = (table: any):ActionFE => ({type: FACTURA_EXPORTACION_TYPES.FE_SET_TABLE_PRODUCTOS, payload: table})

const api_getSucursales = (body: any) => http.post(ENDPOINTS.GESTION_USUARIO_POST_SUCURSALES, body, {}, KEYS.TOKEN)
const api_getRecintosFiscales = () => http.get(ENDPOINTS.GET_RECINTO_FISCAL)
const api_getRegimenes = () => http.get(ENDPOINTS.GET_REGIMEN)
const api_getPaises = () => http.get(ENDPOINTS.GET_PAISES,{}, KEYS.TOKEN)
const api_getIconterms = () => http.get(ENDPOINTS.GET_INCONTERMS)
const api_getFormasPago = () => http.get(ENDPOINTS.GET_FORMA_PAGO)
const api_RecepcionDTE = (body: any) => http.post(ENDPOINTS.FACTURACION_POST_RECEPCION_DTE, body, {}, KEYS.TOKEN)
const api_buscarCliente = (body: any) => http.post(ENDPOINTS.CLIENTE_RECEPTOR_GUARDAR, body,  {}, KEYS.TOKEN)
const api_getUnidadMedida = () => http.get(ENDPOINTS.GET_UNIDAD_MEDIDA)